import React, { Component } from 'react';
import { connect } from 'dva';
import { Drawer, Spin } from 'antd';
import router from 'umi/router';
import SingleResource from './SingleResource';
import style from './index.less';
import SignatureDrawer from './SignatureDrawer';
import GoBack from './GoBack';
import ResourcesFinder from './ResourcesFinder';

@connect(({ universalDrawer, cloudAccount, organisation, resourcesReport }) => ({
  drawerVisible: universalDrawer.drawerVisible,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
  resourcesReport: resourcesReport.report,
  resourceReportLoading: resourcesReport.loadingReport, // resource report loading state
  singleRiskRsources: universalDrawer.filteredResourcesOfSingleRisk, // single risk
  filteredResources: universalDrawer.filteredResources, // list from getFilteredResources action
  currentOrganisation: organisation.current,
  drawerType: universalDrawer.drawerType,
}))
class UniversalDrawer extends Component {
  componentDidMount() {
    const {
      drawerVisible,
      allCloudAccountsList,
      currentOrganisation,
      dispatch,
      resourcesReport,
    } = this.props;

    this.unlisten = this.props.history.listen(location => {
      const { org, dType, filters } = location.query;

      if (org && dType) {
        let parsedFilters = JSON.parse(filters);

        parsedFilters = parsedFilters.filter(v => v.type && v.type.length > 0);

        dispatch({
          type: `universalDrawer/openDrawer`,
        });

        dispatch({
          type: 'universalDrawer/newFilters',
          payload: {
            drawerType: dType,
            filters: parsedFilters,
            orgId: org,
          },
        });
      } else {
        dispatch({
          type: `universalDrawer/closeDrawer`,
        });
      }
    });
  }

  clearUrl = () => {
    let url = window.location.href;
    if (url.includes('localhost')) {
      url = url.split('http://')[1];
    } else {
      url = url.split('https://')[1];
    }
    if (!url) return;
    let indexOfFirstSlash = url.indexOf('/');

    let urlForRouter = url.slice(indexOfFirstSlash).split('?')[0];
    router.push(urlForRouter);
  };

  componentWillUnmount() {
    const { dispatch } = this.props;

    if (this.unlisten) this.unlisten();
  }

  onClose = () => {
    const { dispatch } = this.props;

    dispatch({
      type: `universalDrawer/closeDrawer`,
    });
    dispatch({
      type: 'universalDrawer/clear',
    });

    this.clearUrl();
  };

  render() {
    const { drawerVisible, loadingReport } = this.props;
    // console.log('this.props :>> ', this.props);
    return (
      <Drawer
        // title={<GoBack />}
        headerStyle={{ border: 0 }}
        width={1100}
        style={{ padding: 0, zIndex: 999, overflow: 'auto' }}
        bodyStyle={{ overflowX: 'hidden' }}
        placement="right"
        closable={false}
        onClose={this.onClose}
        destroyOnClose={true}
        maskClosable={true}
        open={drawerVisible}
      >
        {this.DrawerToRender()}
      </Drawer>
    );
  }

  DrawerToRender = () => {
    const {
      drawerType,
      filteredResources,
      visible,
      resourceReportLoading,
      singleRiskRsources,
    } = this.props;
    if (drawerType === 'signatureDrawer') {
      return (
        <Spin
          spinning={
            resourceReportLoading && (singleRiskRsources && singleRiskRsources.length === 0)
          }
        >
          <SignatureDrawer drawerName="Signatures" onClose={this.onClose} visible={visible} />
        </Spin>
      );
    }

    if (drawerType === 'singleResource') {
      return <SingleResource drawerName="Single Resource Drawer" />;
    }

    if (drawerType === 'resourceDrawer') {
      return (
        // we are using loader from resource report model because
        // the list that we are showing has a dependency from RESOURCE REPORT model
        // the below spinner will only work if the loader from Resource report is true and length of our list is zero.
        <Spin
          spinning={resourceReportLoading && (filteredResources && filteredResources.length === 0)}
        >
          <ResourcesFinder />
        </Spin>
      );
    }

    return null;
  };
}

export default UniversalDrawer;
